import { Grid, GridItem, Heading } from '@chakra-ui/react';
import { InputFileInformation } from '@ssar-app/domain';

export interface InputFileSummaryProps {
  inputFile?: InputFileInformation;
}

export const InputFileSummary = (props: InputFileSummaryProps) => {
  return (
    <>
      <Heading
        as={'h3'}
        textAlign={'center'}
        color={'#1d4f91'}
        marginTop={8}
        marginBottom={2}
        fontSize={'sm'}
        fontFamily={'Roboto'}
        fontWeight={'normal'}
      >
        Input File
      </Heading>
      <Grid templateColumns='repeat(6, 1fr)' gap={2}>
        <GridItem textAlign={'right'}>
          <strong>Client File Name:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {props.inputFile?.clientFileName || 'NA'}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>File Name:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {props.inputFile?.fileName || 'NA'}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Record Quantity:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {props.inputFile?.numberOfRecordsExpected || 'NA'}
        </GridItem>
      </Grid>
    </>
  );
};
